module.exports = __webpack_public_path__ + "static/bharat-f32582f7d31b287640e2c9ed82282c37.png";